import { Component, Input, Output, OnInit, EventEmitter } from '@angular/core';
import { DataGridVO } from '@app/shared/custom-component/data-grid/data-grid.model';
import { CommonModule, DatePipe } from '@angular/common';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { DxDataGridModule } from 'devextreme-angular';
import { CalendarModule } from 'primeng/calendar';
import { CheckboxModule } from 'primeng/checkbox';
import { EditorModule } from 'primeng/editor';
import { InputMaskModule } from 'primeng/inputmask';
import { InputTextModule } from 'primeng/inputtext';
import { RadioButtonModule } from 'primeng/radiobutton';
import { DropdownModule } from 'primeng/dropdown';
import { DataGridComponent } from '@app/shared/custom-component/data-grid/data-grid.component';
import * as registrationHeaders from '@app/shared/constants/registration-constants';
import { SsnMaskDirective } from '@app/shared/directives/ssn-mask.directive';
import { ActivatedRoute } from '@angular/router';
import { CommonService } from '@app/shared/services/common.service';
import { take } from 'rxjs';
import { SurrenderService } from '@app/surrender/surrender.service';
import { forkJoin } from 'rxjs';
import { HttpService } from '@app/@core/services/http.service';

@Component({
  selector: 'app-registration-template',
  templateUrl: './registration-template.component.html',
  styleUrls: ['./registration-template.component.scss'],
  standalone: true,
  imports: [
    CommonModule,
    ReactiveFormsModule,
    FormsModule,
    DxDataGridModule,
    CalendarModule,
    CheckboxModule,
    EditorModule,
    InputMaskModule,
    InputTextModule,
    RadioButtonModule,
    DropdownModule,
    DataGridComponent,
  ],
  providers: [DatePipe,SsnMaskDirective]
})
export class RegistrationTemplateComponent implements OnInit {
  // Row arrays for each table (like business rules component)

   paymentTableData: any[] = [];
    // Setup paymentGridConfig for Fee and Payments section
    paymentHeaders = [
      { dataField: 'transaction_id', caption: 'Transaction ID' },
      // { dataField: 'cd_transaction_type', caption: 'Transaction Type' },
      // { dataField: 'application_id', caption: 'Application ID' },
      // { dataField: 'application_type', caption: 'Application Type' },
      { dataField: 'amount', caption: 'Amount' },
      { dataField: 'transaction_date', caption: 'Date' },
      { dataField: 'cd_transaction_status', caption: 'Status' },
      // { dataField: 'transaction_id', caption: 'Transaction ID' }
    ];
    paymentGridConfig: DataGridVO;
  // paymentTableData: any[] = [];
  licenseMasterRows: any[] = [];
  licenseoutofstateLicensureRows: any[] = [];
  licenseKindEndorsementRows: any[] = [];
  priorNamesRows: any[] = [];
  educationRows: any[] = [];
  nevadaTestingRows: any[] = [];
  outOfStateTestingRows: any[] = [];
  workExperienceRows: any[] = [];
  highestEducationRows: any[] = [];

  // Professional Development properties
  profDevData: any;
  profDevCollegeRows: any[] = [];
  profDevEmploymentRows: any[] = [];
  profDevAdditionalRows: any[] = [];
  profDevCollegeGrid: DataGridVO;
  profDevEmploymentGrid: DataGridVO;
  profDevAdditionalGrid: DataGridVO;
  profDevHours: number = 0;
  profDevLabels = [10, 20, 30, 40, 50, 60, 70, 80, 90, "Max"];

  // @Input() applicationData?: any;
  @Input() readOnlyMode?: boolean = true;
  user: any;
  application: any;
  application_license_master: DataGridVO;
  application_out_of_state_licensure: DataGridVO;
  application_license_kind_endorsement: DataGridVO;
  current_license_kind_endorsement: DataGridVO;
  currentLicenseKindEndorsementRows: any[] = [];
  license_provisions: DataGridVO;
  licenseProvisionsRows: any[] = [];
  endorsement_provisions: DataGridVO;
  endorsementProvisionsRows: any[] = [];
  license_requirements: DataGridVO;
  licenseRequirementsRows: any[] = [];
  application_provider: any;
  pf_address_info: any;
  pf_prior_names: DataGridVO;
  pf_name_history: any;
  pf_veteran_status: any;
  application_education: DataGridVO;
  application_nevada_testing: DataGridVO;
  application_out_of_state_testing: DataGridVO;
  application_work_experience: any;
  application_teaching_experience: any;
  application_acknowledgement: any;
  applicationDetails: any;
  application_background_check:any;
  teachingExperienceRows:any;
  surrenderLicenseKindGrid: DataGridVO ;
  surrenderEndorsementGrid: DataGridVO ;
  surrenderNotesGridConfig: DataGridVO ;
  application_prof_dev_district_charter: DataGridVO;
  application_prof_dev_additional: DataGridVO;
  surrenderLicenseKindRows: any[] = [];
  surrenderEndorsementRows: any[] = [];
  surrenderNotesRows: any[] = [];
  surrenderPersonData:any;
  surrenderApplicationData:any;
  license_number:any;
  @Output() legalChangeEvent = new EventEmitter<string>();
  @Output() activeDutyChangeEvent = new EventEmitter<string>();
  @Output() spouseActiveDutyChangeEvent = new EventEmitter<string>();
  @Output() veteranDefinitionChangeEvent = new EventEmitter<string>();
  @Output() spouseVeteranChangeEvent = new EventEmitter<string>();
  appId:any;
  applicationData:any;
  arlProviders:any=[];

  // Supporting documents (mirrors document-upload-grid for role 405, read-only)
  applicationDocuments: any[] = [];
  /** key -> display label for SUPPORTING-DOCUMENT-CATEGORY (top-level categories) */
  private docCategoryLabelMap: Record<string, string> = {};
  /** parent category key -> map of typeKey -> typeLabel */
  private docTypeLabelByCategory: Record<string, Record<string, string>> = {};
  /** Track in-flight requests for type lookups so we only fetch once per category */
  private docTypeFetchInFlight: Record<string, boolean> = {};


  constructor(private datePipe: DatePipe,
    private commonService: CommonService,
    private activatedRoute: ActivatedRoute,
    private surrenderService: SurrenderService,
    private httpService : HttpService,

  ) {

  }

  private makeGridConfig(headers: any[], data: any[], overrides: Partial<DataGridVO> = {}): DataGridVO {
    return DataGridVO.create({
      customHeaders: headers,
      data: Array.isArray(data) ? data : (data ? [data] : []),
      showActionsColumn: false,
      showFiltering: false,
      showSearchRow: false,
      showPaging: false,
      customNoDataText: 'No data',
      role: 'registration',
      activeTab: 'default',
      ...overrides
    });
  }

  ngOnInit(): void {
       this.activatedRoute.paramMap.subscribe(params => {
      this.appId = params.get('appId');
    });

    // Check for pre-injected data from headless PDF generation (bypasses auth)
    const injectedData = (window as any).__PDF_APP_DATA__;
    if (injectedData) {
      const data = injectedData?.data || injectedData;
      if (data) {
        this.applicationData = data;
        if (this.applicationData.application?.[0]?.cd_application_type === 'Surrender') {
          this.fetchSurrenderData(this.applicationData.user?.person?.strUserId, this.appId);
        }
        setTimeout(() => {
          if (this.applicationData) {
            this.loadData();
          }
        }, 500);
        return;
      }
    }

     forkJoin([
      this.httpService.get('/domain/newlookup?requestType=ARL PROVIDER'),
      this.httpService.get('/platform/master/lookup/category/SUPPORTING-DOCUMENT-CATEGORY'),
    ]).subscribe({
      next:(item:any)=>{
        this.arlProviders = item[0];
        this.buildDocCategoryLabelMap(item[1]);
      }
    })

    const externalApplicationData = this.applicationData;
    if (externalApplicationData) {
      setTimeout(() => {
        if (this.applicationData) {
          this.loadData();
        }
      }, 0);
    }

    this.commonService.generateAppPDF(this.appId).pipe(take(1)).subscribe((response: any) => {
      if (response?.status === 'success' && response.data) {
        this.applicationData = response.data;
        if(this.applicationData.application[0].cd_application_type === 'Surrender'){
          this.fetchSurrenderData(this.applicationData.user.person.strUserId,this.appId);
        }
        setTimeout(() => {
          if(this.applicationData){
            this.loadData();
          }
        }, 500);
      }
    });
  }

  loadData(){
     const data = this.applicationData || {};
    this.application = data.application?.[0] || {};
    this.user = data.user || {};
    this.assignRowArrays();
    this.application_license_master = this.makeGridConfig(
      registrationHeaders.jurisdictionHeaders,
      this.licenseMasterRows,
      { fillEmptyRows: true, minVisibleRows: 5 }
    );
    this.application_out_of_state_licensure = this.makeGridConfig(
      registrationHeaders.jurisdictionHeaders,
      this.licenseoutofstateLicensureRows,
      { fillEmptyRows: true, minVisibleRows: 1 }
    );
    this.application_license_kind_endorsement = this.makeGridConfig(
      registrationHeaders.licenseHeaders,
      this.licenseKindEndorsementRows,
      { fillEmptyRows: true, minVisibleRows: 1 }
    );
       this.current_license_kind_endorsement = this.makeGridConfig(
      registrationHeaders.currentLicenseKindEndorsementHeaders,
      this.currentLicenseKindEndorsementRows,
      { fillEmptyRows: true, minVisibleRows: 1 }
    );
      this.license_provisions = this.makeGridConfig(
      registrationHeaders.licenseProvisionsHeaders,
      this.licenseProvisionsRows,
      { fillEmptyRows: false, minVisibleRows: 0 }
    );
      this.endorsement_provisions = this.makeGridConfig(
      registrationHeaders.endorsementProvisionsHeaders,
      this.endorsementProvisionsRows,
      { fillEmptyRows: false, minVisibleRows: 0 }
    );
      this.license_requirements = this.makeGridConfig(
      registrationHeaders.licenseRequirementsHeaders,
      this.licenseRequirementsRows,
      { fillEmptyRows: false, minVisibleRows: 0 }
    );
    this.pf_prior_names = this.makeGridConfig(
      registrationHeaders.priorNamesHeaders,
      this.priorNamesRows
    );
    this.application_education = this.makeGridConfig(
      registrationHeaders.educationHeaders,
      this.educationRows
    );
    this.application_nevada_testing = this.makeGridConfig(
      registrationHeaders.nevadaTestingHeaders,
      this.nevadaTestingRows
    );
    this.application_out_of_state_testing = this.makeGridConfig(
      registrationHeaders.outOfStateTestingHeaders,
      this.outOfStateTestingRows
    );
    this.application_work_experience = this.makeGridConfig(
      registrationHeaders.workExperienceHeaders,
      this.workExperienceRows
    );
    this.application_teaching_experience = this.makeGridConfig(
      registrationHeaders.teachingExperienceHeaders,
      this.teachingExperienceRows
    )
    this.surrenderLicenseKindGrid = this.makeGridConfig(
      registrationHeaders.surrenderLicenseKind,
      this.surrenderLicenseKindRows,
    )
    this.surrenderEndorsementGrid = this.makeGridConfig(
      registrationHeaders.surrenderEndorsement,
      this.surrenderEndorsementRows,
    )
    this.surrenderNotesGridConfig = this.makeGridConfig(
      registrationHeaders.surrendNotes,
      this.surrenderNotesRows,
    )

    // Professional Development grids
    this.profDevCollegeGrid = this.makeGridConfig(
      registrationHeaders.profDevCollegeHeaders,
      this.profDevCollegeRows
    );
    this.application_prof_dev_district_charter = this.makeGridConfig(
      registrationHeaders.profDevEmploymentHeaders,
      this.profDevEmploymentRows
    );
    this.application_prof_dev_additional = this.makeGridConfig(
      registrationHeaders.profDevAdditionalHeaders,
      this.profDevAdditionalRows
    );

    this.application_provider = data.licenseDetails?.application_provider?.[0] || '';
    this.pf_address_info = data.personalInformation?.pf_address_info?.[0] || {};
    this.pf_name_history = data.personalInformation?.pf_name_history?.[0] || {};
    this.pf_veteran_status = data.personalInformation?.pf_veteran_status?.[0] || {};
    this.application_acknowledgement = data?.application_acknowledgement?.[0] || {};
    this.application_background_check = data.backgroundCheck?.application_background_check?.[0] || {};
    this.paymentTableData = (Array.isArray(data.paymentTransaction) ? data.paymentTransaction : []).map(item=>{
      const num = parseFloat((item.amount || '0').replace(/[$,]/g , ''));
      return {
        ...item,
        amount: `$${!isNaN(num) ? Math.floor(num) : '0'}`
      }
    });
    // Setup paymentGridConfig for Fee and Payments section
    const paymentHeaders = [
      { dataField: 'transaction_id', caption: 'Transaction ID', allowSearch: { isSearchEnable: false, type: 'string' } },
      // { dataField: 'cd_transaction_type', caption: 'Transaction Type',  allowSearch: { isSearchEnable: false, type: 'string' } },
      // { dataField: 'application_id', caption: 'Application ID',  allowSearch: { isSearchEnable: false, type: 'string' } },
      // { dataField: 'cd_application_type', caption: 'Application Type',  allowSearch: { isSearchEnable: false, type: 'string' } },
      { dataField: 'amount', caption: 'Amount',  allowSearch: { isSearchEnable: false, type: 'string' } },
      { dataField: 'transaction_date', caption: 'Date',  allowSearch: { isSearchEnable: false, type: 'string' } },
      { dataField: 'cd_transaction_status', caption: 'Status',  allowSearch: { isSearchEnable: false, type: 'string' } },
      // { dataField: 'transaction_id', caption: 'Transaction ID',  allowSearch: { isSearchEnable: false, type: 'string' } }
    ];
    this.paymentGridConfig = DataGridVO.create({
      customHeaders: paymentHeaders,
      data: this.paymentTableData,
      showActionsColumn: false,
      showFiltering: false,
      showSearchRow: false,
      showPaging: false,
      customNoDataText: 'No payment records',
      role: 'registration',
      activeTab: 'default'
    });

   const rawDocs = Array.isArray(data.applicationDocuments) ? data.applicationDocuments : [];
    const seenIds = new Set<string>();
    this.applicationDocuments = rawDocs.filter((doc: any) => {
      const id = doc?.document_id != null
        ? `id:${doc.document_id}`
        : `k:${doc?.file_name || ''}|${doc?.cd_document_category || ''}|${doc?.cd_document_type || ''}|${doc?.section_name || ''}|${doc?.uploaded_at || doc?.created_date || ''}`;
      if (seenIds.has(id)) {
        return false;
      }
      seenIds.add(id);
      return true;
    });
    this.groupedDocuments = this.computeGroupedDocuments();
    this.prefetchDocumentTypeLookups();
  }

  /** Cached grouped view of applicationDocuments (avoids new-reference-per-CD-cycle issues in template). */
  groupedDocuments: { section: string; docs: any[] }[] = [];

  private computeGroupedDocuments(): { section: string; docs: any[] }[] {
    const groups: Record<string, any[]> = {};
    (this.applicationDocuments || []).forEach(doc => {
      const key = (doc?.section_name || 'Unspecified').toString().trim() || 'Unspecified';
      if (!groups[key]) {
        groups[key] = [];
      }
      groups[key].push(doc);
    });
    return Object.keys(groups).sort().map(section => ({ section, docs: groups[section] }));
  }

  fetchSurrenderData(strUserId:any, appId:any){
    this.surrenderLicenseKindRows = [];
    this.surrenderEndorsementRows = [];
    const payload ={
      userId :  Number(strUserId),
      applicationId : Number(appId),
    }
    let license_row = 0;
    let endorse_row = 0;
    this.surrenderService.getSurrenderApplicationData(payload).pipe(take(1))
    .subscribe({
      next:(res:any)=>{
        if(res?.data?.success){
          const data = res?.data?.data;
          this.surrenderPersonData = data.p_profile[0];
          this.surrenderApplicationData = data.p_application[0] ?  data.p_application[0] : null;
          if(this.surrenderApplicationData?.application_type == 'ARL (Alternative Route to Licensure)' || this.surrenderApplicationData?.application_type == 'Substitute + ARL'){
            this.surrenderApplicationData.provider_name = this.arlProviders.data.find((item:any) => item.key === this.surrenderApplicationData.arlprovider)?.value;
          }
          data?.p_license_dtls.forEach(license => {
            const p_license_provisions =[];
            const p_license_endorsements = [];
            if(license.license_kind != null){
              license.licenses.forEach(response =>{
                this.license_number = response.license_number;
                  (response.provisions != null && !p_license_provisions.includes(response.provisions)) ? p_license_provisions.push(response.provisions): null;
                  (response.endorsements != null && !p_license_endorsements.includes(response.endorsements)) ? p_license_endorsements.push(response.endorsements): null;
              })
              const licenseData = {
                license_row_number : license_row++,
                license_kind : license.license_kind,
                provisions: p_license_provisions.length>0 ? p_license_provisions : '-',
                endorsements :p_license_endorsements.length >0 ? p_license_endorsements : '-',
                request_notes : license.license_req_note? license.license_req_note: '-',
                cd_lk_status: license.cd_lk_status ? license.cd_lk_status: null,
                decisionFlag : null,
                action_notes : license.license_analyst_req_note ? license.license_analyst_req_note : null,
                status : null,
              }
              this.surrenderLicenseKindRows.push(licenseData);
            }
          })
          data?.p_endorsement_dtls.forEach(endo => {
            const p_endo_provisions =[];
            if(endo.endorsement != null){
              endo.licenses.forEach(response =>{
                response.provisions != null ? p_endo_provisions.push(response.provisions): null;
              })
              const endoData = {
                endorse_row_number : endorse_row++,
                license_kind : endo.license_kinds ,
                provisions:  p_endo_provisions.length>0 ? p_endo_provisions : '-',
                endorsements :endo.endorsement,
                request_notes: endo.endorse_req_note ? endo.endorse_req_note :'-',
                cd_endo_status : endo.cd_endo_status ? endo.cd_endo_status : null,
                decisionFlag : null,
                action_notes : endo.endorse_analyst_req_note ? endo.endorse_analyst_req_note : null,
                status : null,
              }
              this.surrenderEndorsementRows.push(endoData);
            }
          })
        }
      }
    })
    const payload1 ={
       application_id : this.appId,
    }
    this.surrenderService.selectSurrenderNotes(payload1).pipe(take(1))
    .subscribe({
      next:((res:any)=>{
        this.surrenderNotesRows = res.data;
        // this.loadData();
      })
    })
  }

  private assignRowArrays(): void {
    const data = this.applicationData || {};
    this.licenseMasterRows = data.licenseDetails?.application_license_master || [];
    this.licenseoutofstateLicensureRows = data.licenseDetails?.application_out_of_state_licensure || [];
    this.licenseKindEndorsementRows = data.licenseDetails?.application_license_kind_endorsement || [];
    
      // Map license provisions data
    const rawProvisionsData = data.licenseEndorsementProvisions?.license_provisions || [];
    this.licenseProvisionsRows = rawProvisionsData.map((item: any) => ({
      provision: item.license_provision_value || item.cd_license_provision || '',
      license_kind: item.license_kind_value || item.cd_license_kind || '',
      due_date: item.license_due_date ? this.datePipe.transform(item.license_due_date, 'MM/dd/yyyy') : '',
      resolved_date: item.resolved_date ? this.datePipe.transform(item.resolved_date, 'MM/dd/yyyy') : '',
      additional_text: item.license_additional_text || '',
      status: item.cd_satus || '' 
    }));

    // Map current license kinds/endorsements from the API (already has lookups applied)
    this.currentLicenseKindEndorsementRows = (data.licenseDetails?.current_license_kinds_endorsements || []).map((item: any) => {  
      let endorsementStatus = item.cd_endo_status || item.endorsement_status || item.status || '';
      
      // If status is still empty or numeric, calculate based on expiration date
      if (!endorsementStatus || !isNaN(Number(endorsementStatus))) {
        const expiryDate = item.end_expiry_date ? new Date(item.end_expiry_date) : null;
        if (expiryDate) {
          const today = new Date();
          today.setHours(0, 0, 0, 0);
          expiryDate.setHours(0, 0, 0, 0);
          
          if (expiryDate < today) {
            endorsementStatus = 'Inactive';
          } else {
            // If not expired, check if there's a status indicator
            const statusCode = String(item.cd_endo_status || item.endorsement_status || '').toLowerCase();
            if (statusCode === 'active' || statusCode === '3') {
              endorsementStatus = 'Active';
            } else if (statusCode === 'inactive' || statusCode === '2') {
              endorsementStatus = 'Inactive';
            } else {
              // Default to Active if not expired and no explicit inactive status
              endorsementStatus = 'Active';
            }
          }
        }
      }
      
      return {
        cd_license_type: item.cd_license_type || '',
        cd_license_kind: item.cd_license_kind || '',
        cd_endorsement: item.cd_endorsement || '',
        endorsement_pathway: item.endorsement_pathway || '',
        original_effective_date: item.end_original_issue_date ? this.datePipe.transform(item.end_original_issue_date, 'MM/dd/yyyy') : '',
        effective_date: item.end_issue_date ? this.datePipe.transform(item.end_issue_date, 'MM/dd/yyyy') : '',
        expiration_date: item.end_expiry_date ? this.datePipe.transform(item.end_expiry_date, 'MM/dd/yyyy') : '',
        cd_endo_status: endorsementStatus
      };
    });

      // Map license requirements data - backend returns it under licenseEndorsementProvisions
    const rawLicenseRequirementsData = data.licenseEndorsementProvisions?.license_requirements || [];
    this.licenseRequirementsRows = rawLicenseRequirementsData.map((item: any) => ({
      requirement: item.requirement_value || item.cd_requirement || '',
      type: item.type_value || item.cd_type || '',
      due_date: item.requirement_due_date ? this.datePipe.transform(item.requirement_due_date, 'MM/dd/yyyy') : '',
      resolved_date: item.resolved_date ? this.datePipe.transform(item.resolved_date, 'MM/dd/yyyy') : '',
      additional_text: item.requirement_additional_text || '',
      status: item.cd_satus || ''
    }));

      // Map endorsement provisions data - backend returns it under licenseEndorsementProvisions
    const rawEndorsementProvisionsData = data.licenseEndorsementProvisions?.endorsement_provisions || [];
    console.log('=== ENDORSEMENT PROVISIONS DEBUG ===');
    console.log('Raw endorsement provisions data:', rawEndorsementProvisionsData);
    if (rawEndorsementProvisionsData.length > 0) {
      console.log('First item structure:', rawEndorsementProvisionsData[0]);
      console.log('First item keys:', Object.keys(rawEndorsementProvisionsData[0]));
      console.log('Due date field value (endor_due_date):', rawEndorsementProvisionsData[0].endor_due_date);
      console.log('Due date field value (dueDate):', rawEndorsementProvisionsData[0].dueDate);
      console.log('Due date field value (due_date):', rawEndorsementProvisionsData[0].due_date);
    }
    this.endorsementProvisionsRows = rawEndorsementProvisionsData.map((item: any) => ({
      provision: item.endor_provision_value || item.cd_endor_provision || '',
      endorsement: item.endoresement_value || item.cd_endoresement || '',
      due_date: item.endorsement_due_date ? this.datePipe.transform(item.endorsement_due_date, 'MM/dd/yyyy') : '',
      resolved_date: item.resolved_date ? this.datePipe.transform(item.resolved_date, 'MM/dd/yyyy') : '',
      additional_text: item.endor_additional_text || '',
      status: item.cd_satus || ''  // Note: backend has typo - cd_satus not cd_status
    }));

    this.priorNamesRows = data.personalInformation?.pf_prior_names || [];
    this.educationRows = (data.educationInformation?.application_education || []).map(row => Object.fromEntries(
      Object.entries(row).map(([key, value]) => [key, (value === null || value === undefined || value === "---" ) ? '' : value])));
    this.highestEducationRows = data.educationInformation?.application_highest_education || [];
    this.nevadaTestingRows = data.educationInformation?.application_nevada_testing || [];
    this.outOfStateTestingRows = data.educationInformation?.application_out_of_state_testing || [];
    this.workExperienceRows = data.workExperience?.application_work_experience || [];
    this.teachingExperienceRows = data.workExperience?.application_teaching_experience || [];
    if(this.teachingExperienceRows && this.teachingExperienceRows.length > 0){
      this.teachingExperienceRows.forEach(element => {
        element.cd_date = element ? this.datePipe.transform(element.from_date_of_service, 'MM/dd/yyyy') + '-' + this.datePipe.transform(element.to_date_of_service, 'MM/dd/yyyy') : null;
      });
    }
    if(this.licenseMasterRows.length > 0){
      this.license_number = this.licenseMasterRows[0].license_number || '-';
    }

    // Professional Development data
    this.profDevData = data.professionalDevelopment?.application_professional_development?.[0] || {};
    this.profDevCollegeRows = data.professionalDevelopment?.application_professional_development || [];
    this.profDevEmploymentRows = data.professionalDevelopment?.application_prof_dev_district_charter || [];
    this.profDevAdditionalRows = data.professionalDevelopment?.application_prof_dev_additional || [];
    this.profDevHours = Number(this.profDevData?.total_prof_dev_hrs || 0);
  }

  onChangeUpdateNames(event:any){
    const value = event.target.value === 'yes' ? true : false;
    if(value){
      this.legalChangeEvent.emit('yes');
    }else{
      this.legalChangeEvent.emit('no');
    }
  }

  onChangeActiveDuty(event: any) {
    const value = event.target.value === 'yes' ? true : false;
    if (value) {
      this.activeDutyChangeEvent.emit('yes');
    } else {
      this.activeDutyChangeEvent.emit('no');
    }
  }
// shouldShowLicenseNumberInBanner(appType: string, licenseNumber: string, licensePath: string): boolean {
//     if (!licenseNumber) {
//       return false;
//     }

//     // Show license number for Surrender application if license number exists
//     if (appType?.toLowerCase() === 'surrender') {
//       return true;
//     }

//     // Show license number for Name Change or License Extension only if licensePath is not '3'
//     if ((appType?.toLowerCase() === 'name change' || appType?.toLowerCase() === 'license extension') && licensePath !== '3') {
//       return true;
//     }

//     // For all other cases, don't show license number
//     return false;
//   }
get shouldShowLicenseNumber(): boolean {
    if (!this.license_number) {
      return false;
    }

    const appType = this.application?.cd_application_type?.toLowerCase();

    if (appType === 'surrender') {
      return true;
    }

    if (appType === 'name change' || appType === 'license extension') {
      return false;
    }

    const licensePath = String(this.application?.license_path || '').trim().toLowerCase();
    return licensePath !== '3' && licensePath !== 'initial';
  }
 get shouldShowCurrentLicenseKindEndorsements(): boolean {
    // Show if there's data
    if (this.currentLicenseKindEndorsementRows && this.currentLicenseKindEndorsementRows.length > 0) {
      return true;
    }
    // Also show for RCR applications (Regular-Initial with renewal/convert/reapply paths)
    const appType = String(this.application?.cd_application_type || '').trim().toLowerCase();
    if (appType !== 'regular - initial') {
      return false;
    }
    const licensePath = String(this.application?.license_path || '').trim().toLowerCase();
    // RCR = Renewal, Convert, Re-Apply (accept both mapped labels and raw lookup keys 1/2/4)
    const isRCR = ['renewal', 'renew', 'reapply', 're-apply', 'convert', '1', '2', '4'].includes(licensePath);
    return isRCR;
  }
    get isRCRFlow(): boolean {
    const appType = String(this.application?.cd_application_type || '').trim().toLowerCase();
    if (appType !== 'regular - initial') {
      return false;
    }
    const licensePath = String(this.application?.license_path || '').trim().toLowerCase();
    // RCR = Renewal, Convert, Re-Apply (accept both mapped labels and raw lookup keys 1/2/4)
    return ['renewal', 'renew', 'reapply', 're-apply', 'convert', '1', '2', '4'].includes(licensePath);
  }

   get shouldShowLicenseProvisions(): boolean {
    // Show if there's data
    if (this.licenseProvisionsRows && this.licenseProvisionsRows.length > 0) {
      return true;
    }
    // Also show for RCR applications (Regular-Initial with renewal/convert/reapply paths)
    const appType = String(this.application?.cd_application_type || '').trim().toLowerCase();
    if (appType !== 'regular - initial') {
      return false;
    }
    const licensePath = String(this.application?.license_path || '').trim().toLowerCase();
    // RCR = Renewal, Convert, Re-Apply (accept both mapped labels and raw lookup keys 1/2/4)
    const isRCR = ['renewal', 'renew', 'reapply', 're-apply', 'convert', '1', '2', '4'].includes(licensePath);
    return isRCR;
  }
 get shouldShowEndorsementProvisions(): boolean {
    // Show if there's data
    if (this.endorsementProvisionsRows && this.endorsementProvisionsRows.length > 0) {
      return true;
    }
    // Also show for RCR applications (Regular-Initial with renewal/convert/reapply paths)
    const appType = String(this.application?.cd_application_type || '').trim().toLowerCase();
    if (appType !== 'regular - initial') {
      return false;
    }
    const licensePath = String(this.application?.license_path || '').trim().toLowerCase();
    // RCR = Renewal, Convert, Re-Apply (accept both mapped labels and raw lookup keys 1/2/4)
    const isRCR = ['renewal', 'renew', 'reapply', 're-apply', 'convert', '1', '2', '4'].includes(licensePath);
    return isRCR;
  }

get shouldShowLicenseRequirements(): boolean {
    // Show if there's data
    if (this.licenseRequirementsRows && this.licenseRequirementsRows.length > 0) {
      return true;
    }
    // Also show for RCR applications (Regular-Initial with renewal/convert/reapply paths)
    const appType = String(this.application?.cd_application_type || '').trim().toLowerCase();
    if (appType !== 'regular - initial') {
      return false;
    }
    const licensePath = String(this.application?.license_path || '').trim().toLowerCase();
    // RCR = Renewal, Convert, Re-Apply (accept both mapped labels and raw lookup keys 1/2/4)
    const isRCR = ['renewal', 'renew', 'reapply', 're-apply', 'convert', '1', '2', '4'].includes(licensePath);
    return isRCR;
  }

  get shouldShowProfessionalDevelopment(): boolean {
    const appType = String(this.application?.cd_application_type || '').trim().toLowerCase();
    if (appType !== 'regular - initial') {
      return false;
    }
    const licensePath = String(this.application?.license_path || '').trim().toLowerCase();
    // Accept both mapped labels (renewal/reapply) and raw lookup keys (1/4)
    const isRenewOrReapply = ['renewal', 'renew', 'reapply', 're-apply', '1', '4'].includes(licensePath);
    if (!isRenewOrReapply) {
      return false;
    }
    const licenseType = String(this.licenseMasterRows?.[0]?.cd_license_type || '').trim().toLowerCase();
    return licenseType === 'standard' || licenseType === 'professional';
  }

  onChangeSpouseActiveDuty(event: any) {
    const value = event.target.value === 'yes' ? true : false;
    if (value) {
      this.spouseActiveDutyChangeEvent.emit('yes');
    } else {
      this.spouseActiveDutyChangeEvent.emit('no');
    }
  }

  onChangeVeteranDefinition(event: any) {
    const value = event.target.value === 'yes' ? true : false;
    if (value) {
      this.veteranDefinitionChangeEvent.emit('yes');
    } else {
      this.veteranDefinitionChangeEvent.emit('no');
    }
  }

  onChangeSpouseVeteran(event: any) {
    const value = event.target.value === 'yes' ? true : false;
    if (value) {
      this.spouseVeteranChangeEvent.emit('yes');
    } else {
      this.spouseVeteranChangeEvent.emit('no');
    }
  }

  calculateTextareaRows(text: string | null | undefined): number {
    // Handle empty or null text
    if (!text || text.trim() === '') {
      return 2;
    }

    const lineBreaks = (text.match(/\n/g) || []).length;
    const explicitLines = lineBreaks + 1;

    const charsPerRow = 120;
    const wrappedRows = Math.ceil(text.length / charsPerRow);
    const calculatedRows = Math.max(explicitLines, wrappedRows, 2);
    if (explicitLines === 1) {
      if (text.length <= 120) {
        return 1;
      }
      return wrappedRows;
    }
    return Math.max(Math.floor(calculatedRows - 0.2), 2);
  }

  // Professional Development slider calculations
  get profDevSliderMax(): number {
    return Math.max(100, this.profDevHours);
  }

  get profDevPercent(): number {
    const min = 10;
    const range = this.profDevSliderMax - min;
    const percent = ((this.profDevHours - min) / range) * 100;
    return Math.max(0, Math.min(100, percent));
  }

  getBranchOfServiceArray(branchString: string | null | undefined): string[] {
    if (!branchString) {
      return [];
    }
    return branchString.split(',').map(branch => branch.trim()).filter(branch => branch.length > 0);
  }


  getDocumentsBySection(sectionName: string | string[]): any[] {
    if (!sectionName || !this.applicationDocuments?.length) {
      return [];
    }
    const targets = (Array.isArray(sectionName) ? sectionName : [sectionName])
      .map(name => (name || '').toString().trim().toLowerCase())
      .filter(name => name.length > 0);
    if (targets.length === 0) {
      return [];
    }
    const seen = new Set<string>();
    const result: any[] = [];
    this.applicationDocuments.forEach(doc => {
      const value = (doc?.section_name || '').toString().trim().toLowerCase();
      if (!targets.includes(value)) {
        return;
      }
      // Prefer document_id for identity; fall back to a composite key when missing.
      const id = doc?.document_id != null
        ? `id:${doc.document_id}`
        : `k:${doc?.file_name || ''}|${doc?.cd_document_category || ''}|${doc?.cd_document_type || ''}|${doc?.section_name || ''}|${doc?.uploaded_at || doc?.created_date || ''}`;
      if (seen.has(id)) {
        return;
      }
      seen.add(id);
      result.push(doc);
    });
    return result;
  }

  /** Resolve category display value via SUPPORTING-DOCUMENT-CATEGORY lookup; fallback to raw. */
  getDocCategoryLabel(doc: any): string {
    const raw = doc?.cd_document_category;
    if (raw === null || raw === undefined || raw === '') {
      return '';
    }
    const key = String(raw).trim();
    return this.docCategoryLabelMap[key] || key;
  }

  /**
   * Resolve type display:
   * – If value is numeric / matches a key under the parent category lookup, use its label.
   * – Otherwise display the raw string (free-text values like "Nevada" pass through).
   */
  getDocTypeLabel(doc: any): string {
    const raw = doc?.cd_document_type;
    if (raw === null || raw === undefined || raw === '') {
      return '';
    }
    const rawStr = String(raw).trim();
    const categoryKey = String(doc?.cd_document_category ?? '').trim();
    const typeMap = this.docTypeLabelByCategory[categoryKey];
    if (typeMap && typeMap[rawStr]) {
      return typeMap[rawStr];
    }
    // Numeric value but lookup not present yet → lazily fetch and return raw for now
    if (categoryKey && /^\d+$/.test(rawStr)) {
      this.fetchDocumentTypeLookup(categoryKey);
    }
    return rawStr;
  }

  formatDocumentDate(value: any): string {
    if (!value) {
      return '';
    }
    try {
      return this.datePipe.transform(value, 'MM/dd/yyyy') || '';
    } catch {
      return '';
    }
  }
/**
   * Inline pill style for a document status. Mirrors the palette used by the
   * custom-grid-list status badges so the PDF/preview view matches role 405.
   */
  getDocStatusBadgeStyle(status: any): string {
    const base =
      'display:inline-block; padding:2px 10px; border-radius:999px; font-size:11px; ' +
      'font-weight:600; line-height:1.4; border:1px solid; text-align:center; min-width:80px;';
    const key = String(status || '').trim().toLowerCase();
    let bg = '#f5f5f5';
    let color = '#666666';
    let border = '#dddddd';
    switch (key) {
      case 'deficient':
        bg = '#fff0df'; color = '#b45309'; border = '#ffd0a3';
        break;
      case 'validated':
      case 'valid':
      case 'verified':
      case 'approved':
        bg = '#e8ffc0'; color = '#4f7d00'; border = '#c3ff5b';
        break;
      case 'pending review':
      case 'pending':
      case 'addressed':
      case 'in review':
      case 'submitted':
      case 'new':
        bg = '#fff9d6'; color = '#c69e27'; border = '#f8e7a1';
        break;
      case 'archived':
      case 'replaced':
        bg = '#f0f0f0'; color = '#666666'; border = '#cccccc';
        break;
      case 'rejected':
        bg = '#fee8e8'; color = '#d93025'; border = '#e5a3a3';
        break;
    }
    return `${base} background-color:${bg}; color:${color}; border-color:${border};`;
  }

  private buildDocCategoryLabelMap(response: any): void {
    const rows = this.extractLookupRows(response);
    const map: Record<string, string> = {};
    rows.forEach((row: any) => {
      const key = String(row?.key ?? row?.id ?? '').trim();
      const value = String(row?.value ?? row?.label ?? row?.name ?? key).trim();
      if (key) {
        map[key] = value;
      }
    });
    this.docCategoryLabelMap = map;
  }

  private prefetchDocumentTypeLookups(): void {
    const uniqueCategoryKeys = new Set<string>();
    (this.applicationDocuments || []).forEach(doc => {
      const key = String(doc?.cd_document_category ?? '').trim();
      const typeValue = String(doc?.cd_document_type ?? '').trim();
      // Only fetch when type is numeric and a category key exists
      if (key && typeValue && /^\d+$/.test(typeValue)) {
        uniqueCategoryKeys.add(key);
      }
    });
    uniqueCategoryKeys.forEach(key => this.fetchDocumentTypeLookup(key));
  }

  private fetchDocumentTypeLookup(categoryKey: string): void {
    if (!categoryKey) {
      return;
    }
    if (this.docTypeLabelByCategory[categoryKey] || this.docTypeFetchInFlight[categoryKey]) {
      return;
    }
    this.docTypeFetchInFlight[categoryKey] = true;
    const url = `/platform/master/lookup/category/SUPPORTING-DOCUMENT-CATEGORY?parent=${encodeURIComponent(categoryKey)}`;
    this.httpService.get(url).pipe(take(1)).subscribe({
      next: (response: any) => {
        const rows = this.extractLookupRows(response);
        const map: Record<string, string> = {};
        rows.forEach((row: any) => {
          const key = String(row?.key ?? row?.id ?? '').trim();
          const value = String(row?.value ?? row?.label ?? row?.name ?? key).trim();
          if (key) {
            map[key] = value;
          }
        });
        this.docTypeLabelByCategory[categoryKey] = map;
        this.docTypeFetchInFlight[categoryKey] = false;
      },
      error: () => {
        this.docTypeLabelByCategory[categoryKey] = {};
        this.docTypeFetchInFlight[categoryKey] = false;
      }
    });
  }

  private extractLookupRows(response: any): any[] {
    if (Array.isArray(response?.data?.data)) {
      return response.data.data;
    }
    if (Array.isArray(response?.data)) {
      return response.data;
    }
    if (Array.isArray(response)) {
      return response;
    }
    return [];
  }
}
